import {
  CLEAR_CRM_INTEGRATION,
  GET_CRM_INTEGRATION,
  SET_CRM_INTEGRATION,
} from "./CrmIntegrationTypes";

const getCrmIntegration = () => {
  return {
    type: GET_CRM_INTEGRATION,
  };
};

const setCrmIntegration = (data) => {
  return {
    type: SET_CRM_INTEGRATION,
    payload: data,
  };
};

const clearCrmIntegration = (data) => {
  return {
    type: CLEAR_CRM_INTEGRATION,
    payload: data,
  };
};
const CrmIntegrationAction = {
  getCrmIntegration,
  setCrmIntegration,
  clearCrmIntegration,
};
export default CrmIntegrationAction;
